export default "__VITE_ASSET__DXl3F87i__"